export function popupResetBaseStateRequest() {
  return {
    type: '@popup/RESET_BASE_STATE_REQUEST'
  }
}

export function popupResetBaseStateSuccess() {
  return {
    type: '@popup/RESET_BASE_STATE_SUCCESS'
  }
}

export function popupResetBaseStateFailure() {
  return {
    type: '@popup/RESET_BASE_STATE_FAILURE'
  }
}
